import {
  DYNAMIC_PROCESS_INITIATOR_NOTIFICATION,
  SaveNotificationTemplateForm,
} from "@/modules/admin-panel/notification-templates/features/save-notification-template";
import { DYNAMIC_PROCESS_FORM } from "../dynamic-process-form-provider/forms-enum";
import { Model } from "../../model/types";
import { NotificationForm } from "@/modules/admin-panel/notification-templates/shared/notification-form";

export function InitiatorTemplateForm({ model }: { model: Model }) {
  return (
    <SaveNotificationTemplateForm
      name={DYNAMIC_PROCESS_FORM.INITIATOR}
      code={DYNAMIC_PROCESS_INITIATOR_NOTIFICATION}
      partOf
      initialValues={NotificationForm.transformers.notificationTemplateValueDtoToNotificationTemplateInput(
        model?.initiatorNotificationTemplate?.value,
      )}
    />
  );
}
